import { MESApiService, spParameter } from "@dexteel/mesf-core";

export const getOperators = async (assetId: number, onlyForeman?: boolean) => {
  const apiService = new MESApiService();
  const parameters: spParameter[] = [
    { name: "AssetId", value: assetId },
    { name: "OnlyForeman", value: onlyForeman ?? false },
  ];
  return await apiService.callV2("[STEEL].[GetOperators]", parameters);
};
